export default {
  loading: "Loading points...",
  errorLoad: "Unable to load points",
  title: "My Points",
  description: "Points earned from uploaded restaurant receipts",
  currentBalance: "Current balance",
  pointsLabel: "points",
  recentTitle: "Recent transactions",
  emptyTitle: "No points transactions yet",
  emptyDescription: "Upload a restaurant receipt to earn your first points",
} as const;
